export const stats = [
  { value: '+300', label: 'Ejercicios ilustrados' },
  { value: '+100', label: 'Clases ya armadas' },
  { value: '360', label: 'Páginas en PDF' },
  { value: '6', label: 'Niveles de progresión' },
]

export const beforeItems = [
  'Domingos enteros armando la semana',
  'Rotás las mismas 4 rutinas hace meses',
  'No sabés cómo adaptar a una embarazada',
  'Buscás ideas sueltas en Instagram',
  'Anotás a tus alumnos en el celular',
  'Alumnos que se van a los 3 meses',
]

export const afterItems = [
  'El trimestre resuelto en una carpeta',
  '6 niveles reales de progresión',
  'Tabla de 20 patologías en semáforo',
  'Clases con minutaje ya escritas',
  '18 planillas para tu estudio',
  'Alumnos que ven su progreso y renuevan',
]

export const transformationBadges = [
  { value: '6', label: 'Tomos' },
  { value: '3', label: 'Bonos' },
  { value: '100%', label: 'Imprimible' },
]

export const painPoints = [
  'Son las diez de la noche del domingo y todavía no sabés qué vas a dar mañana.',
  'Rotás las mismas cuatro rutinas hace ocho meses y tus alumnos ya se dieron cuenta.',
  'Entra una alumna embarazada, sonreís, y adaptás sobre la marcha cruzando los dedos.',
  'Pasás más horas preparando clases que dándolas.',
  'Se te van cuatro o cinco alumnos por año y nunca supiste bien por qué.',
]

export const kitContents = [
  {
    title: '6 Tomos de Progresión',
    desc: 'De iniciación a avanzado, un nivel por tomo. 60 páginas cada uno.',
    icon: 'layers' as const,
  },
  {
    title: 'Poblaciones Especiales',
    desc: 'Embarazo, posparto, adultos mayores, hernia de disco, escoliosis y rehabilitación.',
    icon: 'heart' as const,
  },
  {
    title: 'Clases Ya Armadas',
    desc: 'Más de 100 clases completas con minutaje, curva de intensidad y consignas.',
    icon: 'calendar' as const,
  },
  {
    title: 'Material Imprimible',
    desc: 'Fichas recortables, láminas A3 para el estudio y certificados para tus alumnos.',
    icon: 'printer' as const,
  },
]

export const kitHighlight = {
  title: 'El Orden Clásico Completo',
  desc: 'Los 34 ejercicios originales de Joseph Pilates, ilustrados uno por uno, en orden, con repeticiones y transiciones.',
}

export const instantAccessItems = [
  { text: 'Las +100 Clases Armadas', icon: 'calendar' as const },
  { text: 'La Tabla de Contraindicaciones', icon: 'shield' as const },
  { text: '45 Mensajes para tus Alumnos', icon: 'phone' as const },
  { text: 'El Kit de 18 Planillas', icon: 'notebook' as const },
]

export const bonuses = [
  {
    title: 'El Estudio Ordenado',
    desc: 'Kit de 18 planillas del instructor: admisión, anamnesis, consentimiento, asistencia, progreso y cobros.',
    image:
      'https://cdn.magicpatterns.com/uploads/s11J5mNB1TvaQmvtLNFrCM/Captura_de_pantalla_2026-09-07_a_la(s)_9.59.54_a._m..png',
    alt: 'Tapa del bono El Estudio Ordenado.',
  },
  {
    title: 'El Mapa del Cuerpo',
    desc: 'Anatomía aplicada y tabla de 20 patologías en semáforo, con las 12 banderas rojas para derivar.',
    image:
      'https://cdn.magicpatterns.com/uploads/jgihkedd67QP1PdkHR94dU/Captura_de_pantalla_2026-09-07_a_la(s)_10.00.06_a._m..png',
    alt: 'Tapa del bono El Mapa del Cuerpo.',
  },
  {
    title: 'El Año Lleno',
    desc: 'Calendario anual de 12 meses y 45 mensajes listos para copiar y pegar.',
    image:
      'https://cdn.magicpatterns.com/uploads/ddfYf7daHgUTrzrE1YvA4j/Captura_de_pantalla_2026-09-07_a_la(s)_10.00.20_a._m..png',
    alt: 'Tapa del bono El Año Lleno.',
  },
]

export const socialProofPurchases = [
  { name: 'Lucía O.', city: 'Villa Crespo, CABA', minutes: 4 },
  { name: 'Julieta B.', city: 'Córdoba Capital', minutes: 11 },
  { name: 'Rocío F.', city: 'Rosario, Santa Fe', minutes: 19 },
  { name: 'Agustina P.', city: 'San Isidro, Buenos Aires', minutes: 26 },
  { name: 'Malena T.', city: 'Neuquén', minutes: 33 },
]
